import IntroVideoPage from './IntroVideoPage';

export default IntroVideoPage;
